// For TypeScript to correctly infer an array as non-empty, we need to use this
// specific type guard. Can't just do `.length > 0`.
//
// Code copied from https://stackoverflow.com/a/56006703/1292652
//

export const isNonEmptyArray = <T,>(arr: T[]): arr is NonEmptyArray<T> => arr.length > 0;
export type NonEmptyArray<T> = [T, ...T[]];

// If you have an async function (that doesn't return anything), it actually
// returns Promise<void>, which doesn't work type-wise if you want to pass it
// to where expecting a void function. So just wrap your callback with this.
//
// Warning: This creates a new function every time. It does not use `useCallback()`
// to prevent re-renders.
export const ignoreVoidPromiseReturn =
    (callback: () => Promise<void>): (() => void) =>
    () =>
        void callback();
